import { NgModule, Type } from '@angular/core';

import { CslPerfectScrollbarDirective } from './csl-perfect-scrollbar.directive';
import { DefaultImageDirective } from './default-img.directive';
import { DisableInputSpinEventsDirective } from './disable-input-spin-events.directive';
import { EnterLikeTabDirective } from './enter-like-tab.directive';
import { MultipleOfNumberDirective } from './multiple-of-number.directive';
import { OverflowTooltipDirective } from './overflowTooltip.directive';
import { SelectInputsByClickDirective } from './select-inputs-by-click.directive';
import { WaitDirective } from './wait.directive';

const DIRECTIVES: Type<any>[] = [
  EnterLikeTabDirective,
  SelectInputsByClickDirective,
  CslPerfectScrollbarDirective,
  MultipleOfNumberDirective,
  DefaultImageDirective,
  WaitDirective,
  OverflowTooltipDirective,
];

@NgModule({
  imports: [DisableInputSpinEventsDirective],
  declarations: [DIRECTIVES],
  exports: [DIRECTIVES, DisableInputSpinEventsDirective],
})
export class DirectivesModule {}
